function get(route, Dataparams) {
    return jQuery.ajax({
        url: window.ajaxurl,
        type: 'GET',
        data: {
            ...Dataparams,
            action: 'ls_ajax_get',
            route_name: route,
            _ajax_nonce: window.LSAjax._ajax_nonce
        }
    });
}

function post(route, Dataparams) {
    let isFormData = {
        processData: false,
        contentType: false
    };

    // Check if Dataparams is a FormData object
    if (Dataparams instanceof FormData) {
        Dataparams.append('action', 'ls_ajax_post');
        Dataparams.append('route_name', route);
        Dataparams.append('_ajax_nonce', window.LSAjax._ajax_nonce);
    } else {
        // Regular data object
        Dataparams = {
            ...Dataparams,
            action: 'ls_ajax_post',
            route_name: route,
            _ajax_nonce: window.LSAjax._ajax_nonce
        };
    }

    return jQuery.ajax({
        url: window.ajaxurl,
        type: 'POST',
        data: Dataparams,
        ...(Dataparams instanceof FormData) ? isFormData : {}
    });
}

export { get, post } 